import { Switch } from "@headlessui/react";
import React, { useState } from "react";
import { CiEdit } from "react-icons/ci";
import { IoIosStar } from "react-icons/io";
import { ClipLoader } from "react-spinners";
import { toast } from "react-toastify";
import { getApiCaller } from "../../libs/apiCaller";

const ConsumerReviewCard = ({ res, setReviewModal, setEditReviewDetails }) => {
  const [enabled, setEnabled] = useState(res.status || false);
  const [loading, setLoading] = useState(false);

  const updateReviewStatus = async (newStatus, ratingId) => {
    setLoading(true);
    try {
      const response = await getApiCaller(
        `review_status?rating_id=${ratingId}&status=${newStatus ? 1 : 0}`
      );
      if (response.data?.status) {
        toast.success(response.data?.response_message);
      } else {
        toast.error(response.data?.response_message);
      }
    } catch (error) {
      console.error("Error updating status:", error);
      setEnabled(!newStatus); // Revert switch if API fails
    } finally {
      setLoading(false);
    }
  };

  const handleSwitchChange = (ratingId) => {
    const newStatus = !enabled;
    setEnabled(newStatus);
    updateReviewStatus(newStatus, ratingId);
  };

  return (
    <div className="p-4 border rounded-md mb-3">
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-1">
          <IoIosStar className="text-[#DFB300]" size={20} />
          <span className="font-medium">{res?.rating}</span>
        </div>
        <div className="flex items-center gap-2">
          {setEditReviewDetails && (
            <div
              className="bg-green-500 rounded-lg p-1.5 cursor-pointer"
              onClick={() => {
                setReviewModal(true);
                setEditReviewDetails && setEditReviewDetails(res);
              }}
            >
              <CiEdit className="text-white" size={20} />
            </div>
          )}
          <p className="font-semibold">Visible for other consumer :</p>
          <span className="text-sm mr-2 text-[#60646C]">OFF</span>

          <Switch
            checked={enabled}
            onChange={() => handleSwitchChange(res?.review_id)}
            disabled={loading}
            className={`group inline-flex h-6 w-11 items-center rounded-full ${
              loading && enabled ? "justify-end" : "justify-start"
            } transition ${
              enabled ? "bg-[#284184] " : "bg-gray-200 justify-start"
            }`}
          >
            {loading ? (
              <ClipLoader
                size={20}
                color="#ffffff"
                loading={loading}
                className={`${enabled ? "me-1" : "ms-1"} `}
              />
            ) : (
              <span
                className={`size-4 rounded-full bg-white transition ${
                  enabled ? "translate-x-6" : "translate-x-1"
                }`}
              />
            )}
          </Switch>
          <span className="text-sm ml-2 text-[#60646C]">ON</span>
        </div>
      </div>
      <p className="my-1.5">{res?.review}</p>
    </div>
  );
};

export default ConsumerReviewCard;
